import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import classes from './style.module.css';
import PropTypes from 'prop-types';

export default function OAutocomplete({
  data,
  handleClick,
  value,
  label,
  style,
  touched,
  setTouched,
  errorMessage,
  onBlur,
  disabled,
  placeholder,
}) {
  const options = data.map((option) => ({
    id: option.id,
    label: option.vrednost,
    ...option,
  }));
  return (
    <div
      style={{
        display: 'grid',
        marginRight: '5px',
        marginTop: '7px',
        width: '98%',
        ...style,
      }}
    >
      <Autocomplete
        noOptionsText="Nema opcija"
        disabled={disabled}
        value={value || ''}
        sx={{
          '& + .MuiAutocomplete-popper .MuiAutocomplete-option': {
            backgroundColor: '#ffff',
          },
          "& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected='true']":
            {
              backgroundColor: value?.length !== 0 ? '#02286029' : '#ffff',
            },
          "& + .MuiAutocomplete-popper .MuiAutocomplete-option[aria-selected ='true']  .Mui-focused":
            {
              backgroundColor: value?.length !== 0 ? '#02286029' : '#ffff',
            },
          // '& .Mui-focused': {
          //   backgroundColor: '#0080ff17', // Boja pozadine za fokus
          // },
        }}
        disablePortal
        // classes={{
        //   // inputRoot: classes.inputRoot,
        //   option: classes.menuItem,
        //   listbox: classes.box,
        // }}
        id="combo-box-demo"
        isOptionEqualToValue={(option, value) =>
          value !== '' ? option.label === value : value === ''
        }
        onChange={(e, value) =>
          handleClick({
            id: value?.id || null,
            vrednost: value?.label || '',
            ...value,
          })
        }
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            InputLabelProps={{
              style: { color: '#888' },
            }}
            // variant="standard"
            placeholder={placeholder}
            error={touched && value?.length === 0}
            helperText={touched && value?.length === 0 && errorMessage}
            onBlur={
              setTouched !== undefined
                ? () => setTouched(true)
                : onBlur !== undefined
                ? onBlur
                : () => {}
            }
            sx={{
              '& .MuiInput-underline:before': { borderBottomColor: '#022760' },
              '& .MuiInput-underline:after': {
                borderBottom: '1px solid #022760',
                transition: 'none',
              },
              '& .MuiInput-underline:hover:before': {
                borderBottom: '1px solid #022760 !important',
              },
              '& .MuiAutocomplete-input': {
                padding: '3px 4px 2px 5px !important',
              },
            }}
          />
        )}
      />
    </div>
  );
}

OAutocomplete.propTypes = {
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  value: PropTypes.string,
  style: PropTypes.object,
};
